import React from 'react';
import { H3, SmallText } from 'ds/components/typography';
import { useLocale } from 'locale';
import { SafeSuspense } from 'utils/SafeSuspense';
import { Demographics, ILocalDemographic } from 'utils/entities';
import styled from '@emotion/styled';
import { SectionWrapper, SectionHeader } from '../styled';

const PieChartsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-${({ theme }) => theme.isRTL ? 'right' : 'left'}: -${({ theme }) => theme.spacing(1.5)};
  ${({ theme }) => theme.media.showAt({ from: 4 })`
    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-basis: 33.333%;
    };
  `}
`;

const Info = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
  marginTop: theme.spacing(0.5),
}));

const PieChart = React.lazy(() => import('components/PieChart'));

const demographicKeys = [ 'studies', 'occupation', 'ages', 'religion', 'ownership', 'parties2022', 'rooms' ];

interface DemographicChartsProps {
  demographic: { [rating in Demographics]: ILocalDemographic | number };
  areaName: string;
}

export const DemographicCharts: React.FC<DemographicChartsProps> = ({ demographic, areaName }) => {
  const { t } = useLocale();
  return (
    <SectionWrapper>
      <SectionHeader>
        <H3 weight="bold">{t('localPage.neighbours.demographic.title', { areaName })}</H3>
        <Info>{t('localPage.neighbours.demographic.subtitle')}</Info>
      </SectionHeader>
      <PieChartsContainer>
        <SafeSuspense>
          {demographicKeys.map(k => (
            demographic[k] && demographic[k].data && demographic[k].data.length > 0 ? (
              <div>
                <PieChart tooltipEnabled key={k} data={demographic[k].data} title={t('localPage.neighbours.demographic.name', { name: k })} isTouch={false} />
              </div>
            ) : null
          ))}
        </SafeSuspense>
      </PieChartsContainer>
    </SectionWrapper>
  );
};
